<template>
    <CCard class="page mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <CRow>
                <CCol>
                    <h1 class="page__title">{{ deliveryCampaign ? deliveryCampaign.name : $t(titlePage) }}</h1>
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid>
                <CRow>
                    <CCol sm="12">
                        <CCard>
                            <CCardHeader>
                                <CCol md="1">
                                    <ButtonBack class="mr-3" title="Go back" />
                                </CCol>
                            </CCardHeader>
                            <CCardBody>
                                <CContainer fluid class="p-0">
                                    <CRow alignHorizontal="center">
                                        <CCol md="10" sm="12">
                                            <CCard>
                                                <CCardHeader>
                                                    <p class="mb-0">
                                                        {{
                                                            $t(
                                                                "configure_import_description"
                                                            )
                                                        }}
                                                    </p>
                                                </CCardHeader>
                                                <CCardBody>
                                                    <CContainer>
                                                        <CRow>
                                                            <CCol>
                                                                <label
                                                                    class="font-weight-bold"
                                                                >
                                                                    {{
                                                                        $t(
                                                                            "format"
                                                                        )
                                                                    }}
                                                                </label>
                                                                <CSelect
                                                                    :options="[
                                                                        {
                                                                            value: 'csv',
                                                                            label: $t(
                                                                                'csv'
                                                                            ),
                                                                        },
                                                                    ]"
                                                                    size="sm"
                                                                    class="font-weight-bold"
                                                                    :isValid="
                                                                        checkIfFormValid(
                                                                            {
                                                                                form_name:
                                                                                    'uploadDeliveriesFile',
                                                                                field_name:
                                                                                    'format',
                                                                            }
                                                                        )
                                                                    "
                                                                    :value.sync="
                                                                        $v.forms
                                                                            .uploadDeliveriesFile
                                                                            .format
                                                                            .$model
                                                                    "
                                                                />
                                                            </CCol>
                                                            <CCol>
                                                                <label
                                                                    class="font-weight-bold"
                                                                >
                                                                    {{
                                                                        $t(
                                                                            "delimiter"
                                                                        )
                                                                    }}
                                                                </label>
                                                                <CSelect
                                                                    :options="[
                                                                        {
                                                                            value: ',',
                                                                            label: ',',
                                                                        },
                                                                        {
                                                                            value: ';',
                                                                            label: ';',
                                                                        },
                                                                        {
                                                                            value: ' ',
                                                                            label: $t(
                                                                                'space'
                                                                            ),
                                                                        },
                                                                    ]"
                                                                    size="sm"
                                                                    class="font-weight-bold"
                                                                    :isValid="
                                                                        checkIfFormValid(
                                                                            {
                                                                                form_name:
                                                                                    'uploadDeliveriesFile',
                                                                                field_name:
                                                                                    'delimiter',
                                                                            }
                                                                        )
                                                                    "
                                                                    :value.sync="
                                                                        $v.forms
                                                                            .uploadDeliveriesFile
                                                                            .delimiter
                                                                            .$model
                                                                    "
                                                                />
                                                            </CCol>
                                                            <CCol>
                                                                <label
                                                                    class="font-weight-bold"
                                                                >
                                                                    {{
                                                                        $t(
                                                                            "quote"
                                                                        )
                                                                    }}
                                                                </label>
                                                                <CSelect
                                                                    :options="[
                                                                        {
                                                                            value: '',
                                                                            label: 'Without quote',
                                                                        },
                                                                        {
                                                                            value: 'quote',
                                                                            label: 'Quote',
                                                                        },
                                                                        {
                                                                            value: 'double_quote',
                                                                            label: 'Double quote',
                                                                        },
                                                                    ]"
                                                                    size="sm"
                                                                    class="font-weight-bold"
                                                                    :isValid="
                                                                        checkIfFormValid(
                                                                            {
                                                                                form_name:
                                                                                    'uploadDeliveriesFile',
                                                                                field_name:
                                                                                    'delimiter',
                                                                            }
                                                                        )
                                                                    "
                                                                    :value.sync="
                                                                        $v.forms
                                                                            .uploadDeliveriesFile
                                                                            .quote
                                                                            .$model
                                                                    "
                                                                />
                                                            </CCol>
                                                            <CCol>
                                                                <label
                                                                    class="font-weight-bold"
                                                                >
                                                                    {{
                                                                        $t(
                                                                            "end_line"
                                                                        )
                                                                    }}
                                                                </label>
                                                                <CSelect
                                                                    :options="[
                                                                        {
                                                                            value: '\n',
                                                                            label: '\\n',
                                                                        },
                                                                        {
                                                                            value: '\r\n',
                                                                            label: '\\r\\n',
                                                                        },
                                                                    ]"
                                                                    class="font-weight-bold"
                                                                    size="sm"
                                                                    :isValid="
                                                                        checkIfFormValid(
                                                                            {
                                                                                form_name:
                                                                                    'uploadDeliveriesFile',
                                                                                field_name:
                                                                                    'endLine',
                                                                            }
                                                                        )
                                                                    "
                                                                    :value.sync="
                                                                        $v.forms
                                                                            .uploadDeliveriesFile
                                                                            .endLine
                                                                            .$model
                                                                    "
                                                                />
                                                            </CCol>
                                                        </CRow>

                                                        <CRow>
                                                            <CCol md="12">
                                                                <CInputCheckbox
                                                                    :checked.sync="
                                                                        $v.forms
                                                                            .uploadDeliveriesFile
                                                                            .acceptedPolicies
                                                                            .$model
                                                                    "
                                                                    :label="
                                                                        $t(
                                                                            'i_confirm_that_all_subscribers_uploaded_gave_clear_consent_to_the_management_of_their_information_by_my_company'
                                                                        )
                                                                    "
                                                                    :isValid="
                                                                        checkIfFormValid(
                                                                            {
                                                                                form_name:
                                                                                    'uploadDeliveriesFile',
                                                                                field_name:
                                                                                    'acceptedPolicies',
                                                                            }
                                                                        )
                                                                    "
                                                                    :invalidFeedback="
                                                                        $t(
                                                                            'it_is_necessary_to_accept_the_policies'
                                                                        )
                                                                    "
                                                                />
                                                            </CCol>
                                                        </CRow>
                                                    </CContainer>
                                                </CCardBody>
                                            </CCard>
                                        </CCol>
                                    </CRow>

                                    <CRow alingHorizontal="center">
                                        <CCol md="10" sm="12">
                                            <CCButtonUploadFile
                                                ref="inputUploadFile"
                                                uploadType="delivery-campaigns-deliveries"
                                                @change="uploadFile"
                                            >
                                            </CCButtonUploadFile>
                                        </CCol>
                                    </CRow>

                                    <CRow alignHorizontal="center">
                                        <CCol md="10" sm="12">
                                            <h5>{{ $t("file_fields") }}</h5>
                                            <p class="mb-0">
                                                {{
                                                    $t(
                                                        "file_fields_description"
                                                    )
                                                }}.
                                            </p>

                                            <CCTable
                                                :items="
                                                    tables
                                                        .allowedFieldsConfiguration
                                                        .items
                                                "
                                                :fields="
                                                    tables
                                                        .allowedFieldsConfiguration
                                                        .fields
                                                "
                                                :resizable="false"
                                            >
                                                <template
                                                    #file_fields="{ item }"
                                                >
                                                    <SelectAsync
                                                        :options="headers"
                                                        :value.sync="
                                                            item.file_fields
                                                        "
                                                        :placeholder="
                                                            $t(
                                                                'Select a field to map'
                                                            )
                                                        "
                                                        size="sm"
                                                    />
                                                </template>
                                                <template
                                                    #default_value="{ item }"
                                                >
                                                    <DatePicker
                                                        v-if="item.allowed_fields == 'sent_at'"
                                                        v-model="
                                                            item.default_value
                                                        "
                                                        :max-date="new Date()"
                                                        :model-config="
                                                            vCalendar.modelConfig
                                                        "
                                                    >
                                                        <template
                                                            v-slot="{
                                                                inputValue,
                                                                inputEvents,
                                                            }"
                                                        >
                                                            <CInput
                                                                :value="inputValue"
                                                                v-on="inputEvents"
                                                                :placeholder="
                                                                    $t(
                                                                        'Select a default value'
                                                                    )
                                                                "
                                                                size="sm"
                                                            />
                                                        </template>
                                                    </DatePicker>
                                                    <CSelect
                                                        v-else-if="item.allowed_fields == 'status'"
                                                        :value.sync="
                                                            item.default_value
                                                        "
                                                        :placeholder="
                                                            $t('Select a default value')
                                                        "
                                                        class="mb-0"
                                                        size="sm"
                                                        :options="[
                                                            'ok',
                                                            'ko',
                                                            'duplicate',
                                                            'err'
                                                        ]"
                                                    >

                                                    </CSelect>
                                                </template>
                                            </CCTable>
                                        </CCol>
                                    </CRow>
                                    <CRow alignHorizontal="center">
                                        <CCol
                                            class="d-flex justify-content-end"
                                            md="10"
                                            sm="12"
                                        >
                                            <ButtonLoading
                                                color="primary"
                                                @click="sendForm()"
                                                :loading="forms.uploadDeliveriesFile._loading"
                                            >
                                                {{ $t("Import data") }}
                                            </ButtonLoading>
                                        </CCol>
                                    </CRow>
                                </CContainer>
                            </CCardBody>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
import SelectAsync from "£lement/SelectAsync";
import SelectTags from "£lement/SelectTags";
import ButtonBack from "£lement/ButtonBack";
import CCTable from "~/components/CCTable";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import CCButtonUploadFile from "~/components/CCButtonUploadFile";
import ButtonLoading from "~/components/ButtonLoading.vue";
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { cilTrash, cilArrowBottom, cilArrowTop, cilPlus } from "@coreui/icons";
import { CCol, CRow } from "@coreui/vue";

const isTrue = (value) => {
    return value === true ? true : false;
};

export default {
    name: "DeliveryCampaignImportDeliveriesConfigurationPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, validationMixin, tableMixin],

    icons: {
        cilTrash,
        cilArrowTop,
        cilArrowBottom,
        cilPlus,
    },

    components: {
        SelectAsync,
        ButtonBack,
        SelectTags,
        CCTable,
        CCButtonUploadFile,
        ButtonLoading,
        DatePicker
    },
    data() {
        return {
            vCalendar: {
                modelConfig: {
                    type: "string",
                    mask: "YYYY-MM-DD HH:mm:ss", // Uses 'iso' if missing
                },
            },
            deliveryCampaign: null,
            headers: [],
            firstLine: null,
            forms: {
                uploadDeliveriesFile: {
                    file: null,
                    format: "csv",
                    delimiter: ",",
                    quote: '"',
                    endLine: "\n",
                    acceptedPolicies: false,
                    _loading: false,
                },
            },
            tables: {
                allowedFieldsConfiguration: {
                    items: [
                        {
                            allowed_fields: "lead_id",
                            file_fields: null,
                            default_value: null,
                        },
                        {
                            allowed_fields: "status",
                            file_fields: null,
                            default_value: null,
                        },
                        {
                            allowed_fields: "sent_at",
                            file_fields: null,
                            default_value: null,
                        },
                    ],
                    fields: [
                        {
                            key: "allowed_fields",
                            label: "Allowed fields",
                        },
                        {
                            key: "file_fields",
                            label: "File fields",
                        },
                        {
                            key: "default_value",
                            label: "Default value",
                        },
                    ],
                },
            },
        };
    },
    computed: {
        uuid: function () {
            return this.$route.params.uuid;
        },
    },
    watch: {
        "forms.uploadDeliveriesFile.delimiter"(newValue, oldValue) {
            if (this.firstLine) {
                this.headers = this.firstLine.split(newValue);
            }
        },
    },
    validations: {
        forms: {
            uploadDeliveriesFile: {
                file: {
                    required,
                },
                format: {
                    required,
                },
                delimiter: {
                    // required
                },
                quote: {},
                endLine: {
                    // required
                },
                acceptedPolicies: {
                    required,
                    isTrue,
                },
            },
        },
    },

    methods: {
        async uploadFile(e) {
            this.firstLine = e.firstLine;
            this.headers = this.firstLine.split(
                this.forms.uploadDeliveriesFile.delimiter
            );
        },

        async loadDeliveryCampaign() {
            const response = await this.fetcher({
                url: `/campaigns.api/${this.uuid}`,
            });
            this.deliveryCampaign = response._items;
        },

        async sendForm() {
            try {
                this.updatePageLoading(true);
                this.forms.uploadDeliveriesFile._loading = true;
                const refInputUploadFile = this.$refs["inputUploadFile"];
                const { key, fileName } = await refInputUploadFile.saveFile();

                let mappingFields = {};
                let defaultValues = {};
                for (let i = 0; i < this.tables.allowedFieldsConfiguration.items.length; i++) {
                    const item = this.tables.allowedFieldsConfiguration.items[i];

                    mappingFields = {
                        ...mappingFields,
                        [item.allowed_fields]: item.file_fields
                            ? item.file_fields
                            : null,
                    };

                    defaultValues = {
                        ...defaultValues,
                        [item.allowed_fields]: item.default_value
                            ? item.default_value
                            : null,
                    };
                }

                await this.fetcher({
                    baseURL: process.env.VUE_APP_API_SASS,
                    // baseURL: "http://localhost:3000/prod",
                    url: `/imports/delivery-campaigns-deliveries/${key}/process`,
                    method: "POST",
                    data: {
                        fileName,
                        deliveryCampaignId: this.deliveryCampaign.id,
                        delimiter: this.forms.uploadDeliveriesFile.delimiter,
                        acceptedPolicies: this.forms.uploadDeliveriesFile.acceptedPolicies,
                        key,
                        allowedFieldsMapping: mappingFields,
                        allowedFieldsDefaultValues: defaultValues,
                    },
                });

                this.showMessageSuccess();
                this.$router.push({
                    name: "delivery_campaigns_imports",
                });
            } catch (error) {
                this.showMessageError(error);
            } finally {
                this.forms.uploadDeliveriesFile._loading = false;
                this.updatePageLoading(false);
            }
        },
    },
    async mounted() {
        await this.loadDeliveryCampaign();
        this.updatePageLoading(false);
    },
};
</script>

<style lang="scss" scoped>
.input-fields {
    margin-bottom: 1rem;
}
</style>
